import { Tag } from 'common/OptionSelect/Tag'
import { ReactNode } from 'react'
import Styles from './CalendarEventCard.module.scss'

export interface StatusPillProps {
  status: ReactNode
  color: string
  fontColor: string
  testId: string
}

export const StatusPill = ({ status, color, fontColor, testId }: StatusPillProps) => {
  return (
    <div className={Styles.statusCornerContainer}>
      <div className={Styles.statusPill} data-testid={testId}>
        <Tag size="md" color={color} fontColor={fontColor}>
          {status}
        </Tag>
      </div>
    </div>
  )
}
